"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _overrides = require("../../../utils/overrides");

var _Label = _interopRequireDefault(require("../Label"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var _Switch = _interopRequireDefault(require("../Switch"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'SwitchInput');

function SwitchInput(_ref) {
  var _classnames;

  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      label = _ref.label,
      labelMode = _ref.labelMode,
      isFullWidth = _ref.isFullWidth,
      hint = _ref.hint,
      error = _ref.error,
      checked = _ref.checked,
      isRequired = _ref.isRequired,
      isReadOnly = _ref.isReadOnly,
      isRange = _ref.isRange,
      onChange = _ref.onChange,
      value = _ref.value,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className", "label", "labelMode", "isFullWidth", "hint", "error", "checked", "isRequired", "isReadOnly", "isRange", "onChange", "value"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, SwitchInput.overrides); // Classes

  var rootClassName = (0, _classnames2.default)(classes.root, (_classnames = {}, (0, _defineProperty2.default)(_classnames, classes.isReadOnly, isReadOnly), (0, _defineProperty2.default)(_classnames, classes[labelMode], labelMode), (0, _defineProperty2.default)(_classnames, classes.isFullWidth, isFullWidth), (0, _defineProperty2.default)(_classnames, classes.errored, error), _classnames), classNameProp);
  var rootProps = {
    className: rootClassName
  };
  var labelProps = (0, _extends2.default)({
    className: classes.Label,
    isRequired: isRequired,
    hint: hint
  }, override.Label);
  var onSwitch = (0, _react.useCallback)(function () {
    onChange && onChange(!value);
  }, [onChange, value]);
  var switchProps = (0, _extends2.default)({
    className: classes.switchinput,
    onChange: onSwitch,
    checked: !!value,
    isDisabled: isReadOnly
  }, override.Switch);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, rootProps, override.root), label && /*#__PURE__*/_react.default.createElement(_Label.default, labelProps, label), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.formControl
  }, override.formControl), /*#__PURE__*/_react.default.createElement(_Switch.default, switchProps), error && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.error
  }, override.error), error)));
}

SwitchInput.overrides = ['root', 'Switch', 'error', 'formControl', 'Label', 'overlay', 'overlayLabel'];
SwitchInput.defaultProps = {
  overrides: {},
  labelMode: 'horizontal',
  onChange: function onChange() {},
  isReadOnly: false
};
process.env.NODE_ENV !== "production" ? SwitchInput.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  label: _propTypes.default.string,
  labelMode: _propTypes.default.oneOf(['horizontal', 'vertical']),
  value: _propTypes.default.any,
  onChange: _propTypes.default.func,

  /** Info popover */
  hint: _propTypes.default.string,

  /** Error will be displayed below the component with style changes */
  error: _propTypes.default.string,
  isReadOnly: _propTypes.default.bool
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(SwitchInput);

exports.default = _default;